import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { Link as MuiLink } from '@mui/material';
import { editPostPath } from '../../../Utils/routes';
import useSpace from '../../../Hooks/useSpace';

interface CallbackLinkProps {
  to: string;
  children: React.ReactNode;
  onClick?: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
}

const CallbackLink: React.FC<CallbackLinkProps> = ({ to, children, onClick, ...rest }) => {
  const handleClick = (event: any) => {
    // Call the provided onClick callback
    if (onClick) {
      onClick(event);
    }

    // Allow the Link component to handle the actual routing
    if (event.defaultPrevented) {
      // Prevent the link action if the default action has been prevented
      return;
    }
  };

  return (
    <Link to={to} onClick={handleClick} {...rest}>
      {children}
    </Link>
  );
};

function QuestionMissingWarning({ post, onClose }: any) {
  const { space } = useSpace();

  return (
    <FormattedMessage
      id="PUBLISHING_POST_DIALOG.NO_QUESTIONS_WARNING"
      values={{
        link: (
          <MuiLink
            component={CallbackLink}
            to={editPostPath(space.slug, post.slug, post.type) + '/questions'}
            onClick={onClose}
          >
            <FormattedMessage id="PUBLISHING_POST_DIALOG.NO_QUESTIONS_WARNING_LINK_TEXT" />
          </MuiLink>
        ),
      }}
    />
  );
}

export default QuestionMissingWarning;
